module.exports = __webpack_public_path__ + "static/media/sand_clock.24527a8b.svg";